export class FundsAtClosing {
  constructor() {
    this.closingCosts = 0; // RECALCULATE, this should be the SUM of closing costs
    this.prepaidExpenses = 0;
    this.loanAmount = 0;
    this.earnestMoney = 0;
    this.totalFundsAtClosing = 0; // RECALCULATE, this should be the SUM of FundsAtClosing
    this.firstLoan = 0;
    this.secondLoan = 0;
    this.baseLoan = 0;
    this.initialDrawFromLoan = 0; // heloc: CashRequested from cashout module
    this.addlLoan = 0; // heloc default MVP
    this.payoffMortgage = 0; // heloc default MVP
    this.payoffOther = 0; // heloc default MVP
    this.appraisalFeeInAdvance = 0; // heloc default MVP
    this.calculatedLoanAmount = 0;
  }
}
